import { EventViewData } from 'components/eventView/pages/eventData';

export const FjellsportEvent: EventViewData = {
    eventId: 'fjellsport',
    mapId: 'aa078a07-88f1-4c57-837a-64b9dd178102',
    guideId: '25e39241-9280-4a2e-8507-47485ccf9e9c',
    mapWrapper: 'fjellsport'
};
